import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "exechangar:soundSettings";

const DEFAULTS = {
  enabled: true,
  volume: 70,
  pitch: 880,
};

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULTS;
    const parsed = JSON.parse(raw);
    return {
      enabled: typeof parsed.enabled === "boolean" ? parsed.enabled : DEFAULTS.enabled,
      volume:
        typeof parsed.volume === "number" && parsed.volume >= 0 && parsed.volume <= 100
          ? parsed.volume
          : DEFAULTS.volume,
      pitch:
        typeof parsed.pitch === "number" && parsed.pitch >= 440 && parsed.pitch <= 1320
          ? parsed.pitch
          : DEFAULTS.pitch,
    };
  } catch {
    return DEFAULTS;
  }
}

function saveToStorage(settings) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // quota exceeded or private browsing — silently ignore
  }
}

export { DEFAULTS as SOUND_DEFAULTS };

export function useSoundSettings() {
  const [settings, setSettings] = useState(loadFromStorage);

  // Persist whenever settings change
  useEffect(() => {
    saveToStorage(settings);
  }, [settings]);

  const setSoundEnabled = useCallback((enabled) => {
    setSettings((prev) => ({ ...prev, enabled }));
  }, []);

  const setSoundVolume = useCallback((volume) => {
    setSettings((prev) => ({ ...prev, volume }));
  }, []);

  const setSoundPitch = useCallback((pitch) => {
    setSettings((prev) => ({ ...prev, pitch }));
  }, []);

  return {
    soundEnabled: settings.enabled,
    soundVolume: settings.volume,
    soundPitch: settings.pitch,
    setSoundEnabled,
    setSoundVolume,
    setSoundPitch,
  };
}
